import styled from "styled-components";
export const Styles = styled.div`
  .main-details-container {
    display: flex;
    flex-direction: column;
    gap: 30px;
    .header-data {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 30px;
      .panel-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 20px;
        width: 100%;
        height: 250px;
        margin-bottom: 70px;
      }
      .logo-container {
        width: 150px;
        height: 150px;
        border-radius: 7px;
        overflow: hidden;
        background: radial-gradient(circle, #51aafd, #002d68);
        .final-logo-container {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          padding: 40px;
          width: 100%;
          height: 100%;
          overflow: hidden;
          white-space: nowrap;
          .final-logo {
            font-weight: 700;
            line-height: 50px;
          }
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .title-container {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        .title {
          font-weight: 700;
          line-height: 48px;
          font-size: 30px;
          text-align: start;
        }
      }
      .panel-url {
        font-weight: 600;
        line-height: 25px;
        font-size: 16px;
        text-align: start;
        width: 100%;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
      
    }
    .panel-another-data {
      display: flex;
      flex-direction: column;
      gap: 30px;
      .panel-date {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        width: 100%;
        flex-direction: row;
        gap: 12px;
        .title {
          font-size: 20px;
          line-height: 25px;
          font-weight: 600;
          text-align: start;
        }
        .domain {
          font-weight: 400;
          font-size: 20px;
          line-height: 20px;
          text-align: start;
        }
        .duration {
          font-weight: 600;
          font-size: 20px;
          line-height: 20px;
        }
      }
     
      .payment-methods {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .title {
          font-size: 20px;
          line-height: 25px;
          font-weight: 600;
        }
        .data {
          font-weight: 400;
          line-height: 18px;
          font-size: 14px;
          margin-top: 10px;
        }
      }
    }
  }
`;
